module.exports = __webpack_public_path__ + "img/title-line.640ff385.svg";